import { render } from "./AddPaywallModal.vue?vue&type=template&id=54137263&scoped=true"
import script from "./AddPaywallModal.vue?vue&type=script&lang=js"
export * from "./AddPaywallModal.vue?vue&type=script&lang=js"

import "./AddPaywallModal.vue?vue&type=style&index=0&id=54137263&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54137263"],['__file',"src/components/modals/AddPaywallModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54137263"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54137263', __exports__)) {
    api.reload('54137263', __exports__)
  }
  
  module.hot.accept("./AddPaywallModal.vue?vue&type=template&id=54137263&scoped=true", () => {
    api.rerender('54137263', render)
  })

}


export default __exports__